import { MacCoreFactory } from './MacCoreFactory';
import { WebCoreFactory } from './WebCoreFactory';
import { LinuxCoreFactory } from './LinuxCoreFactory';
import {
  PlatformType,
  SoloNativeRTCChannel,
} from '@amzn/work-spaces-web-client-core-lib';

let factory;
if (SoloNativeRTCChannel.isChannelAvailable()) {
  if (SoloNativeRTCChannel.getPlatform() === PlatformType.MACOS) {
    factory = new MacCoreFactory();
  } else {
    factory = new LinuxCoreFactory();
  }
} else {
  factory = new WebCoreFactory();
}

export const CoreFactory = factory;
